import { render, staticRenderFns } from "./window-item-primary.vue?vue&type=template&id=161e5c1a&scoped=true&"
import script from "./window-item-primary.vue?vue&type=script&lang=js&"
export * from "./window-item-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161e5c1a",
  null
  
)

export default component.exports